export const MEDIA_TYPES = {
  CAROUSEL_ALBUM: 'CAROUSEL_ALBUM',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
};
